const toggle_password = document.getElementById("toggle-password") as HTMLElement;
const password = document.getElementById("customer_password") as HTMLInputElement;
toggle_password.addEventListener("click", (e) => {
  console.log(e.target);
  const type = password.getAttribute("type") === "password" ? "text" : "password";
  password.setAttribute("type", type);
  if (type === "text") {
    toggle_password.innerHTML = "visibility_off";
  } else {
    toggle_password.innerHTML = "visibility";
  }
});
